import React from 'react';
import styled from 'styled-components';

type FieldsetProps = {
  children: React.ReactNode | React.ReactNodeArray;
  legend: string;
  className?: string;
  dataTestId?: string;
  onChangeCallback?: (event: React.FormEvent<HTMLElement>) => void;
};

const FieldsetStyled = styled.fieldset`
  margin-top: var(--spacing-space4);
`;

// Required for accessibility
const Legend = styled.legend`
  position: absolute;
  height: 1px;
  width: 1px;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
`;

function Fieldset({ children, className, dataTestId, legend, onChangeCallback }: FieldsetProps) {
  return (
    <FieldsetStyled
      className={`fuse-checkbox-group__fieldset ${className}`}
      data-testid={dataTestId}
      onChange={onChangeCallback}
    >
      <Legend>{legend}</Legend>
      {children}
    </FieldsetStyled>
  );
}

export default React.memo(Fieldset);
